import { API_URL } from "env";

interface ProductListParams {
    type: number;
    limit?: number;
    page?: number;
}

interface ProductItem {
    id: number;
    name: string;
    slug: string;
    product_category_id: number;
    price: number;
    discount: number;
    avatar: string;
    is_active: number;
    is_highlight: number;
    short_content: string;
    position: number;
}

interface ProductData {
    total: number;
    current_page: number;
    items: ProductItem[];
}

interface ProductsResponse {
    status: boolean;
    data: ProductData;
    msg?: string;
}

async function fetchProductList(params?: ProductListParams): Promise<ProductsResponse> {
    const query = new URLSearchParams();
    if (params) {
        if (params.type) query.append('type', String(params.type)); // 1: high profit, 2: most sold
        if (params.limit) query.append('limit', String(params.limit));
        if (params.page) query.append('page', String(params.page));
    }

    const url = `${API_URL.replace(/\/$/, '')}/api/v1/fe/product_customs${query.toString() ? `?${query.toString()}` : ''}`;

    try {
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Failed to fetch product list:', error);
        return { status: false, data: { total: 0, current_page: 0, items: [] }};
    }
}

export { fetchProductList };